import userMessageType from "../../actions/userMessage/userMessageType";

const initialState = {
  count_unread_message: 0,
};

const userMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case userMessageType.SET_UPDATE_COUNT_UNREAD_MESSAGE:
      return {
        ...state,
        count_unread_message: action.payload,
      };

    default:
      return state;
  }
};

export default userMessageReducer;
